import styled from 'styled-components';

const Content = styled.div`
`;

export default Content;
